var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEndCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#E86550"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.514 22.856c1.618-.891 4.062-1.487 7.332-1.787A27.421 27.421 0 0126.791 21c.65 0 1.352.023 2.104.069 2.501.093 4.746.617 6.733 1.57 1.5.72 2.617 1.57 3.354 2.554a3 3 0 01.6 1.8v1.537a2.264 2.264 0 01-2.264 2.264c-.887 0-2.073-.242-3.556-.726a2 2 0 01-1.354-1.583l-.285-1.764a1 1 0 00-.617-.77c-1.469-.586-3.18-.878-5.135-.878-1.903 0-3.412.281-4.529.845a1 1 0 00-.543.78l-.19 1.664a2 2 0 01-1.422 1.693c-1.676.493-2.896.739-3.66.739A2.027 2.027 0 0114 28.767v-1.705a3 3 0 01.638-1.85c.71-.906 1.668-1.691 2.876-2.356z",
    fill: "#FFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCallIcon);
export default __webpack_public_path__ + "static/media/EndCallIcon.4491d50f7dad213aeaa8f6288ed1a0f1.svg";
export { ForwardRef as ReactComponent };